const notFoundMessageGenerator = (name: string) =>
  `${name}データが見つかりませんでした。`;

export const notFoundMessages = {
  userList: notFoundMessageGenerator('ユーザー一覧'),
  user: notFoundMessageGenerator('ユーザー'),
  csvList: notFoundMessageGenerator('CSV一覧'),
  csv: notFoundMessageGenerator('CSV'),
  koumutenList: notFoundMessageGenerator('工務店一覧'),
  koumuten: notFoundMessageGenerator('工務店'),
  companyList: notFoundMessageGenerator('設計会社一覧'),
  company: notFoundMessageGenerator('設計会社'),
  modelList: notFoundMessageGenerator('指定された設計会社の推論モデル一覧'),
  model: notFoundMessageGenerator('推論モデル'),
  projectList: notFoundMessageGenerator('指定された設計会社のプロジェクト一覧'),
  project: notFoundMessageGenerator('プロジェクト'),
  image: notFoundMessageGenerator('画像情報'),
  modelImageList: notFoundMessageGenerator('指定された推論モデルの画像一覧'),
  projectImageList: notFoundMessageGenerator(
    '指定されたプロジェクトの画像一覧'
  ),
  labelList: notFoundMessageGenerator('ラベル一覧'),
  annotationList: notFoundMessageGenerator('アノテーション一覧'),
  trainingList: notFoundMessageGenerator('学習済み推論モデル一覧')
} as const;
